module.exports = __webpack_public_path__ + "assets/3ff3253a5a44d6a7bf50d563af08bb72.mp3";